if (!customElements.get('akumi-site-footer')) {
  customElements.define('akumi-site-footer', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.groups = [...this.querySelectorAll('.akumi-site-footer__group')];
      this.handleResize = () => this.syncGroups();
      this.handleSummary = (event) => {
        if (!this.media.matches && event.target.closest('.akumi-site-footer__group > summary')) event.preventDefault();
      };
      this.media.addEventListener('change', this.handleResize);
      this.addEventListener('click', this.handleSummary);
      this.syncGroups();
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.handleResize);
      this.removeEventListener('click', this.handleSummary);
    }
    syncGroups() {
      this.groups.forEach((group) => {
        group.open = !this.media.matches;
        group.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
      });
    }
  });
}
